import Action from '../../Action'
// import './styles/ModalDeleteUSer.css'
import { useEffect, useState } from 'react';
import LoadSimple from '../../LoadSimple';
import { capitalizeFirstLetter } from '../../../utils/utils';
import '../WorkFlow.css'
import { lang } from '../../generales/traduction';
// import Search from '../../../generales/Search';
// import Paginador from '../../../generales/Paginador';
import WorkflowApp from './WorkflowApp';
const ModalCreateWorkFlow =({server,page,setPage,buscar_cis,languaje,mode,hosts,handleShowPopup,closCreateCisModal})=>{
  const [poolRows,setPoolRows]=useState([])
  const [allSelected, setAllSelected] = useState(false);
  const [hostSelected,setHostSelected]=useState(hosts.filter(item => poolRows.includes(item.hostid)))
  const [contRowsSelected,setContRowSelected]=useState(0)
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [limitList, setLimitList] = useState(50);
  const [pageActual, setPageActual] = useState(1);
  const [searchResult, setSearchResult] = useState(null);
  const [disabled,setDisabled]=useState(true)
  const [disabledPage1,setDisabledPage1]=useState(true)
  const [loading,setLoading]=useState(false)

  var dataList = searchTerm === "" ? hosts : searchResults;
  const startLimit = limitList * pageActual - limitList;
  const pages = parseInt(dataList.length / limitList) + 1;
  const handleSelectAll = () => {
      if (allSelected) {
        // Si ya está todo seleccionado, deselecciona todo
        setPoolRows([]);
      } else {
        setPoolRows(hosts.map(item => item.hostid))
      }
      setAllSelected(!allSelected); // Alterna el estado de seleccionar todo
    };
  const handleSearch = (query) => {
    setSearchResult(`Resultados para: ${query}`);
  };
  const handleSelectChange = (e) => {
    setPageActual(1)
    setLimitList(e.target.value);setPageActual(1);
  };
  const rowSelected = (elemento) => {
    if (allSelected) {
      setAllSelected(false)
    }

    setPoolRows((prevRows) => {
      // Busca si el hostid ya existe en el array
      const exists = prevRows.includes(elemento.hostid);
      // Si existe, filtra para eliminarlo, si no existe, lo agrega
      if (exists) {
        return prevRows.filter(hostid => hostid !== elemento.hostid);
      } else {
        return [...prevRows, elemento.hostid];
      }
    });
    setHostSelected((prevRows) => {
        // Busca si el hostid ya existe en el array de objetos
        const exists = prevRows.some(item => item.hostid === elemento.hostid);
        
        // Si existe, filtra para eliminar el objeto, si no existe, lo agrega
        if (exists) {
          return prevRows.filter(item => item.hostid !== elemento.hostid);
        } else {
          return [...prevRows, elemento];
        }
      });
  };
  const [dataWorkFlow,setDataWorkFlow]=useState({
    name: "",
    description: "",
    hostid: null,
    groupid: null,
    metric_id:0,
    trigger_id: 0,
    action_id: 0,
    action_retry_times:1,
    interested_user_group_ids: [],
    telegram_groups:[]
  })
  const Registrar=()=>{
    setLoading(true)
    const fetchDataPost = async () => {
      // const data={
      //   host:'',
      //   measurement:11,
      //   trigger:13,
      //   event:'',
      //   delay:'00:10',
      //   notification:[7],
      //   group:''
      // }
   try {
     // console.log(localStorage.getItem('access_token'))
     const response = await fetch(server.url+'/api/v1/cassia/workflow_actions/', {
       method: 'POST',  
       headers: {
          "Accept": "application/json",
         // 'Content-Type': 'application/json',
         'Content-Type': 'application/json',
           Authorization: `Bearer ${localStorage.getItem('access_token')}`,
         },
       body: JSON.stringify(dataWorkFlow),
     });
     if (response.ok) {
       
       const data1 = await response.json();
       setLoading(false)
       // Manejo de la respuesta
       // setData(data1)
      
       handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']),capitalizeFirstLetter((lang[languaje]['regGenCorr'])),'', true)
       // console.log(data1);
       closCreateCisModal()
     setPage(true)
     buscar_cis()
     
   
     } else {
       const data1 = await response.json();
       handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),data1.detail, false)
       throw new Error('Error en la solicitud');
     }
   } catch (error) {
         
          
      setLoading(false)
       
        closCreateCisModal()
      //   handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regNoGenCorr']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
        
        console.error(error);
      }
    };

    fetchDataPost();
  }
  useEffect(()=>{
    if(dataWorkFlow.name=="" || dataWorkFlow.description==""){
      setDisabledPage1(true)
    }else{
      setDisabledPage1(false)
    }

    // if((dataWorkFlow.hostid==null && dataWorkFlow.groupid==null) || dataWorkFlow.metric_id==0 || dataWorkFlow.trigger_id==0 || dataWorkFlow.action_id==0 || dataWorkFlow.action_delay==""
    //   || (dataWorkFlow.interested_user_group_ids.length==0 && dataWorkFlow.telegram_groups.length==0 )){
    //     setDisabled(true)
    //   }else{
    //     setDisabled(false)
    //   }
    if((dataWorkFlow.hostid==null && dataWorkFlow.groupid==null)   || dataWorkFlow.action_id==0 ){
        setDisabled(true)
      }else{
        setDisabled(false)
      }
  },[dataWorkFlow])
  const handleChange=(e)=>{
    const {name,value}=e.target

    setDataWorkFlow((prevState)=>{
        return {
            ...prevState,
            [name]:value
        }
        
    })
  }
  const reqField=()=>{
    return(
      <p className='reqField-gs'>
        *
      </p>
    )
  }
  const {name,description}=dataWorkFlow;

  return(
      <>
      <div className="modal-GS-content">
      {
        (page)?<>
        <div className='card-modal-gs modal-verificate'>
              <div className='head-card-modal-gs'>
                  <div className='title-head-card-modal-gs'>
                      {(lang[languaje]['agregar'].toUpperCase())+' FLUJO DE ACCIONE'}
                  </div>
              </div>
              <div className='content-card-modal-gs' style={{overflowY: 'scroll',scrollbarWidth: 'thin'}}>
              
                                  <div className="form-GS-box"> 
                                  
                                  <div className="user-box-GS"  style={{height:'33%'}}>
                                  <input required name="name"  type="text" value={name}
                                  onChange={handleChange}  />
                                      <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['nombre'])}{(name=="")?reqField():''}</label>
                                      
                                  </div>
                                  <div className="user-box-GS"  style={{height:'33%'}}>
                                  <input required name="description"  type="text" value={description}
                                  onChange={handleChange}  />
                                      <label className='label-GS  '>{capitalizeFirstLetter(lang[languaje]['descripcion'])}{(description=="")?reqField():''}</label>
                                      
                                  </div>
                                  
                              
                                 
                                  
                                  
                                  <div className="user-box-GS" style={{height:'50%'}}>
                                      {
                                          
                                          <>
                                           {/* <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['regresar'])}  action={closCreateCisModal}/> */}
                                          <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={closCreateCisModal}/>
                                          <Action disabled={disabledPage1} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['siguiente'])}  action={()=>setPage(false)}/>
                                          </>
                                          // <Action disabled={disabled} origen='Login' titulo='Guardar'  action={Registrar}/>
                                      }
                                          
                                  {
                                      // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>Usuario registrado correctamente</span>:''
                                  }
                                      
                                  </div>
                              </div>
              </div>
              </div>
        </>:
        <div className='card-modal-gs modal-verificate'>
              <div className='head-card-modal-gs'>
                  <div className='title-head-card-modal-gs'>
                  {lang[languaje]['crear'].toUpperCase()+" "+lang[languaje]['workflow'].toUpperCase()}
                  </div>
              </div>
              {/**/}
              <div className='content-card-modal-gs' style={{overflowY: 'scroll',scrollbarWidth: 'thin'}}>

                {/*  */}
              <div className='compatWorkflow'>
                  <div className='contentDragDropWorkflow'>
                  <WorkflowApp dataWorkFlow={dataWorkFlow} setDataWorkFlow={setDataWorkFlow} server={server} languaje={languaje}  mode={mode} hosts={hosts} />
                  </div>
                  <div className='contentButtomsWorkflow'>
                  <div className="form-GS-box"> 
                  <div className="user-box-GS" style={{height:'100%'}}>
                                      {
                                          (loading)?<LoadSimple></LoadSimple>
                                          :
                                          <>
                                          <Action disabled={false} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['regresar'])}  action={()=>setPage(true)}/>
                                          <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={closCreateCisModal}/>
                                          <Action disabled={disabled} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['guardar'])}  action={Registrar}/>
                                          </>
                                          // <Action disabled={disabled} origen='Login' titulo='Guardar'  action={Registrar}/>
                                      }
                                          
                                  {
                                      // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>Usuario registrado correctamente</span>:''
                                  }
                                      
                                  </div>
                                  </div>
                  </div>
              </div>
              </div>
          </div>
      }
          </div>
      </>
  )
}

export default ModalCreateWorkFlow